export class FeesProcedureProfessionalModel {
    public idFeesProcedureProfessional: number;
    public datetimeInclusion: Date;
    public idFeesProcedure: number;
    public idProfessionalAgreement: number;
}